export default "__VITE_ASSET__ofioDFLW__"